import React, { useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { Box, InputLabel, MenuItem, Select, TextField } from "@mui/material";

// Actions
import { getSeasons } from "../../../redux/actions/league-action";

// Components
import SMPFields from "./Components/SMPFields";
import DMPFields from "./Components/DMPFields";
import POTYFields from "./Components/POTYFields";
import LCLFields from "./Components/LCLFields";

// Mock Data
import { handicapData, typeData } from "./mockData";

// Styles
export const useStyles = makeStyles(() => ({
  textFieldStyles: {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
  },

  inputLableStyles: {
    marginBottom: "8px !important",
    fontSize: "15px !important",
    fontWeight: "700 !important",
  },

  btn: {
    maxWidth: "170px",
    width: "100%",
    background: "#06623B !important",
    marginLeft: "10px !important",
    borderRadius: "5px !important",
    color: "#fff !important",
  },

  cellStyle: {
    border: "1px solid #7D7D7D !important",
    maxWidth: "40px",
    height: "40px",
    textAlign: "center !important",
  },
}));

const CreateLeague = ({ leagueData, handleFieldChange }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  // Selectors
  const seasonsList = useSelector((state) => state?.seasonListReducer);

  // UseEffect
  useEffect(() => {
    dispatch(getSeasons());
  }, []);

  useEffect(() => {
    if (seasonsList.data?.data && leagueData.seasonID === "") {
      handleFieldChange(seasonsList.data.data[0].name, "seasonID");
    }
  }, [seasonsList]);

  return (
    <Box sx={{ p: "1.5em 0" }}>
      {/* League Name */}
      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>Name</InputLabel>
        <TextField
          fullWidth
          name="name"
          variant="outlined"
          value={leagueData.name}
          className={classes.textFieldStyles}
          onChange={(e) => handleFieldChange(e.target.value, "name")}
        />
      </Box>

      {/* Type */}
      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>Type</InputLabel>

        <Select
          fullWidth
          name="league_type"
          variant="outlined"
          value={leagueData.league_type}
          className={classes.textFieldStyles}
          onChange={(e) => handleFieldChange(e.target.value, "league_type")}
        >
          {typeData.map(({ id, name }) => (
            <MenuItem key={id} value={name}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </Box>

      {/* League Season */}
      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>Season</InputLabel>
        <Select
          fullWidth
          name="seasonID"
          variant="outlined"
          value={leagueData?.seasonID}
          className={classes.textFieldStyles}
          defaultValue=""
          onChange={(e) => handleFieldChange(e.target.value, "seasonID")}
        >
          {seasonsList?.data &&
            seasonsList.data.data?.map((item) => (
              <MenuItem key={item?._id} value={item?.name} onClick={() => {}}>
                {item?.name}
              </MenuItem>
            ))}
        </Select>
      </Box>

      {/* Handicap Differential */}
      <Box sx={{ mb: 1.5 }}>
        <InputLabel className={classes.inputLableStyles}>
          Handicap Differential
        </InputLabel>
        <Select
          fullWidth
          variant="outlined"
          name="handicap_diffrential"
          value={leagueData.handicap_diffrential}
          className={classes.textFieldStyles}
          onChange={(e) =>
            handleFieldChange(e.target.value, "handicap_diffrential")
          }
        >
          {handicapData.map(({ id, name }) => (
            <MenuItem key={id} value={name} onClick={() => {}}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </Box>

      {/* Conditional Fields */}
      {leagueData.league_type == "SMP" ? (
        <SMPFields
          leagueData={leagueData}
          handleFieldChange={handleFieldChange}
        />
      ) : leagueData.league_type == "DMP" ? (
        <DMPFields
          leagueData={leagueData}
          handleFieldChange={handleFieldChange}
        />
      ) : leagueData.league_type == "POTY" ? (
        <Box sx={{ overflowX: "scroll" }}>
          <POTYFields
            leagueData={leagueData}
            handleFieldChange={handleFieldChange}
          />
        </Box>
      ) : (
        leagueData.league_type == "LCL" && (
          <LCLFields
            leagueData={leagueData}
            handleFieldChange={handleFieldChange}
          />
        )
      )}
    </Box>
  );
};

export default CreateLeague;
